var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersNoLicenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EDEDF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9272 9.00003C25.9358 8.99162 22.1083 10.5856 19.3023 13.4239C16.4964 16.2627 14.9469 20.1086 15.0014 24.0991C15.0563 28.09 16.7099 31.892 19.5923 34.6522V51.4872C19.5987 51.8877 19.8057 52.259 20.1433 52.4744C20.4802 52.6727 20.8939 52.6899 21.2459 52.5205L29.9271 48.1799L38.6084 52.5205C38.7669 52.5938 38.9392 52.6327 39.1138 52.6354C39.3241 52.6394 39.5311 52.5838 39.7109 52.4744C40.0485 52.259 40.2556 51.8877 40.262 51.4872V34.6522C43.1444 31.8915 44.798 28.0897 44.8529 24.0991C44.9073 20.1081 43.3578 16.2621 40.5519 13.4239C37.7461 10.5855 33.9187 8.99163 29.9272 9.00003ZM17.2959 23.9281C17.2942 19.6639 19.4441 15.687 23.0126 13.3533C26.5807 11.0192 31.0858 10.6427 34.9919 12.3525C38.8984 14.0623 41.6782 17.6275 42.3843 21.8323C43.0904 26.0375 41.627 30.3148 38.4935 33.2067H38.4707C38.3978 33.2948 38.3129 33.3721 38.218 33.4362C35.9255 35.4495 32.9783 36.5597 29.9273 36.5597C26.8763 36.5597 23.929 35.4495 21.6366 33.4362C21.5417 33.3721 21.4568 33.2948 21.3839 33.2067H21.3611C18.7706 30.8166 17.297 27.4524 17.2959 23.9281ZM26.6498 25.6506L23.375 22.4558L27.9018 21.799L29.9271 17.6951L31.9529 21.799L36.4797 22.4558L33.2044 25.6506L33.9762 30.161L29.9272 28.0295L25.8782 30.161L26.6498 25.6506Z",
    fill: "#C3C8D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 43.6364,
    fill: "white",
    transform: "translate(15 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersNoLicenses);
export default __webpack_public_path__ + "static/media/customers_no_licenses.d0084e0dfbe9ccc72d23c4d4213f818b.svg";
export { ForwardRef as ReactComponent };